<template>
  <div>
    <b-breadcrumb :items="breadCrumbs" />

    <div class="row mb-3">
      <div class="col-12">
        <b-btn
          variant="primary"
          size="md"
          class="float-right"
          :to="'/raw/shipments/add'"
          >Add Raw Shipment</b-btn
        >
      </div>
    </div>

    <b-row class="mt-3">
      <b-col md="12">
        <b-table :items="shipments" :fields="fields" v-if="shipments">
          <template slot="cell(product)" slot-scope="row">
            <ul>
              <li :key="index" v-for="(item, index) in row.item.product">
                {{
                  item.ingredient_name + " " + item.quantity + item.quantity_type + " " + item.raw_shipment_product_id + "_" +item.supplier_code
                }}
              </li>
            </ul>
          </template>
          <template slot="cell(actions)" slot-scope="row">
            <div style="width:300px;" v-if="row.item.status_id != 3">
              <b-button
                size="sm"
                variant="warning"
                class="ml-2"
                :to="'/raw/shipments/' + row.item.raw_shipment_id + '/edit/'"
                >Edit</b-button
              >
              <b-button
                size="sm"
                variant="info"
                class="ml-2"
                :to="'/raw/shipments/' + row.item.raw_shipment_id + '/product/'"
                >Product</b-button
              >
              <b-button
                size="sm"
                variant="danger"
                class="ml-2"
                @click="deleteConfirm(row.item.raw_shipment_id)"
                >Delete</b-button
              >
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-if="!shipments || shipments.length == 0">
      <b-col md="6" class="my-1 offset-md-3">
        <b-alert show variant="success">No raw shipments yet!</b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "raw-shipments",
  components: {},
  data() {
    return {
      shipments: null,
      fields: [
        { key: "raw_shipment_id", label: "#", sortable: true },
        { key: "tracking_number", label: "Tracking Number", sortable: true  },
        { key: "shipping_date", label: "Shipping Date" },
        { key: "product", label: "Product" },
        { key: "actions", label: "" }
      ],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Raw Shipments", active: true }
      ]
    };
  },
  mounted: function() {
    this.getRawShipments();
  },
  methods: {
    getRawShipments: function() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/raw/shipments").then(
        response => {
          this.shipments = response.data.raw_shipments;

          // console.log(this.shipments);

          loader.hide();
        },
        error => {
          loader.hide();
          // console.log(error);
        }
      );
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to delete raw shipment: " + id,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.deleteRawShipment(id);
        }
      });
    },
    deleteRawShipment(id) {
      let loader = this.$loading.show();
      this.$http.delete(this.APIURL + this.BRAND + "/raw/shipments/" + id).then(
        () => {
          this.$swal({
            title: "Success!",
            showConfirmButton: false,
            timer: 1000,
            html: "Raw Shipment deleted successfully!",
            type: "success",
            onClose: () => {
              loader.hide();
              this.getRawShipments();
            }
          });
        },
        error => {
          console.log(error);
        }
      );
    },
    updateRawShipmentStatus(id, status_id) {
      let loader = this.$loading.show();
      this.$http
        .put(this.APIURL + this.BRAND + "/raw/shipments/" + id + "/status", {
          status_id: status_id
        })
        .then(
          response => {
            if (response.data.status == "success") {
              this.$swal({
                title: "Success!",
                showConfirmButton: false,
                timer: 1000,
                html: "Raw Shipment updated successfully!",
                type: "success",
                onClose: () => {
                  loader.hide();
                  this.getRawShipments();
                }
              });
            } else {
              this.$swal({
                title: "Error!",
                showConfirmButton: false,
                timer: 1500,
                html: response.data.error,
                type: "success",
                onClose: () => {
                  loader.hide();
                }
              });
            }
          },
          error => {
            console.log(error);
          }
        );
    }
  }
};
</script>
